<a [routerLink]="['/overview']" class="app-title" [class.pe-none]="externalApp">
    <div fxLayoutAlign="start center" fxLayoutGap="12px">
        <img src="../../../../assets/images/viessmann-white.svg" class="logo-img" />
        <div fxHide.lt-sm fxLayoutAlign="start center" fxLayoutGap="12px">
            <div class="dot"></div>
            <span>{{ externalApp || 'HEADER.APP-TITLE' | translate }}</span>
        </div>
    </div>
</a>
